export default function DocumentsController(
  $scope,
  $stateParams,
  $window,
  documentsService,
  NotificationService,
  notificationHelper,
  sortableHelper,
  UtilService,
  DOCUMENT_STATUSES,
) {
  var vm = this;

  vm.isLoading = false;
  vm.merchantId = $stateParams.merchantId;
  vm.documentStatuses = DOCUMENT_STATUSES;
  vm.documents = [];

  vm.documentListOptions = {
    updated: false,
    update: function() {
      this.updated = true;
    },
    stop: function(event, ui) {
      if (this.updated) {
        updateSortOrder(event, ui);
        this.updated = false;
      }
    },
    start: function() {
      sortableHelper.adjustTop(this);
    },
  };

  vm.init = init;
  vm.deleteDocument = deleteDocument;

  var listener = $scope.$on('merchant.tab.services.selected', vm.init);

  function init() {
    getDocuments();
  }

  function getDocuments() {
    enableLoading();
    documentsService
      .getDocuments(vm.merchantId)
      .then(function(res) {
        vm.documents = res.data;
      })
      .catch(function(res) {
        notificationHelper.showError(res, 'Error getting documents');
      })
      .finally(disableLoading);
  }

  function deleteDocument(documentId) {
    if (vm.isLoading) {
      return;
    }
    if ($window.confirm('Are you sure you want to delete this document?')) {
      enableLoading();
      documentsService
        .deleteDocument(vm.merchantId, documentId)
        .then(function() {
          NotificationService.success('Document successfully deleted');
          vm.documents = [];
          getDocuments();
        })
        .finally(disableLoading);
    }
  }

  function updateSortOrder(event, ui) {
    var documentId, newPosition;
    if (ui.item && ui.item.length && ui.item[0].id) {
      documentId = parseInt(ui.item[0].id, 10);
      newPosition = UtilService.findElementPositionById(vm.documents, documentId);
      if (newPosition >= 0) {
        enableLoading();
        documentsService
          .updateSortOrder(vm.merchantId, documentId, newPosition)
          .then(function() {
            NotificationService.success('Document sort order updated');
          })
          .catch(function() {
            NotificationService.error('Error updating document sort order. Please refresh the page and try again.');
          })
          .finally(disableLoading);
      }
    }
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/documents/documents.controller.js